import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  trans,
  HeaderComponent,
  EmployeeWithProfile,
  PaginationComponent, CustomButton
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants";
import { Badge, message, Popconfirm } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { getAllDataReq, getFilterReq } from "./requests";

import RequestAsTab from "../../../common/RequestAsTab";
import ViewFlow from '@mods/common/ViewFlow';
import ViewLeaveApprovalHistory from '../../common/ViewLeaveApprovalHistory';
import UpdateRelaxationApproval from "../../common/UpdateRelaxationApproval";
import { getRequestFilters } from '@mods/common/commonFilterFields';
import { approveBulkRequests } from "@mods/common/requests";
import { convertTimeTotz } from '@comps/commonFunctions';
import { useLocation } from "react-router-dom";

const langKey = Const["relaxationApproval"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["relaxationApproval"].route
      }
    ]
  }
}

const IndexRelaxationApprovals = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [asFilters, setAsFilters] = useState([]);
  const [requestAs, setRequestAs] = useState(8)
  const [noOfNotifications, setNoOfnotifications] = useState(null)
  const [filters, setFilters] = useState();
  const [delegator, setDelegator] = useState('')
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ================================== UpdateLocation
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'employment_id',
      title: trans(`${langKey}.employment_id`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.requestor } />
      },
    },
    {
      key: 'department_name',
      title: trans(`${langKey}.department_name`),
      render: (record) => {
        return record.requestor.department_name;
      }
    },
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      render: (record) => {
        return convertTimeTotz(record.date).format('YYYY-MM-DD')
      }
    },
    {
      key: 'time_slot_name',
      title: trans(`${langKey}.time_slot_name`),
      dataIndex: "time_slot_name",
    },
    {
      key: 'time',
      title: trans(`${langKey}.time`),
      render: (record) => {
        return convertTimeTotz(record.start_time).format('hh:mm a') + '-To-' + convertTimeTotz(record.end_time).format('hh:mm a')
      }
    },
    {
      key: 'duration',
      title: trans(`${langKey}.duration`),
      render: (record) => {
        return (Math.floor(record.minutes) >= 60 ? Math.floor(record.minutes / 60) + 'h ' + record.minutes % 60 + 'm' : Math.floor(record.minutes) + 'm')
      }
    },
    {
      key: 'next_requestee',
      title: trans(`${langKey}.next_requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onViewHistory={ (record.status === 'Completed' || record.status === 'Rejected') ? onViewHistory : '' }
          onViewFlow={ record.flow.length !== 0 ? onViewFlow : '' }
          onEdit={ (record.status === 'Pending') ? onEdit : '' }
          onView={ onView }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================
  const location = useLocation();
  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [location.pathname, filters, requestAs, currentPage]);

  const getAllData = () => {
    let payload = {
      page: currentPage,
      filters: filters,
      data: { request_as: requestAs, delegator_id: delegator },
      api: props.api
    }
    if (props.api === 'relaxationDelegates' && !delegator) {
      setDataSource([])
      setAsFilters([]);
      onOpenFilter()
      return;
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setNoOfnotifications(response.relaxations.length);
    setPagination(response.relaxations);
    setDataSource(response.relaxations.data);
    setAsFilters(response.filters);
  };

  const onEdit = (record) => {
    setChildComponent(
      <UpdateRelaxationApproval onCompleted={ onCompleted } record={ record } disabled={ false } requestAsId={ requestAs } delegatorId={ delegator } api={ props.api } filters={ filters } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateRelaxationApproval onCompleted={ onCompleted } record={ record } disabled={ true } requestAsId={ requestAs } />
    );
  };
  const onViewHistory = (record) => {
    setChildComponent(
      <ViewLeaveApprovalHistory onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };
  const onViewFlow = (record) => {
    setChildComponent(
      <ViewFlow onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
  }

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ onApplyFilter } onCloseFilter={ onCloseFilter }
    />
    )
  }
  const onApplyFilter = (filters) => {
    setFilters(filters);
    getDelegatorId(filters)
    setChildComponent(null);
  }
  const getDelegatorId = (filters) => {
    // Given string
    const inputString = filters;
    // Regular expression pattern to match the desired string
    const pattern = /delegator_\|(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/;
    //Extracting the match from the string
    const match = inputString && inputString.match(pattern);
    // Check if a match is found
    if (match) {
      const delegatorValue = match[1]; // Extract the UUID part
      setDelegator(delegatorValue)
    } else {
      setDelegator(delegator)
    }
  }
  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------
  //================Start bulk approved=================================
  const [selectedRows, setSelectedRows] = useState([]);
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows)
    },
    getCheckboxProps: (record) => ({
      disabled: record.status !== 'Pending',
      // Column configuration not to be checked
      name: record.name,
    }),
  };
  const onApproveBulk = (isApproval) => {
    const data = [];
    selectedRows.forEach((request, key) => {
      request.request_as = requestAs
      request.is_approval = isApproval
      //request.last_remarks = 'bulk'
      //request.remarks = 'bulk'
      const payload = {
        request: request, delegator_id: delegator
      }
      data.push(payload)
    })
    const bulkData = {
      data: data,
      api: props.api + "/approve-bulk",
      method: 'post'
    }
    makeRequest(setLoader, approveBulkRequests, bulkData, onBulkApproved, onError);
  }
  const onBulkApproved = (approval) => {
    setSelectedRows([]);
    message.success('Success')
    getAllData();
  }
  //================End bulk approved=================================


  //==============================================================================
  return (
    <>

      { childComponent }
      <BodyComponent>
        <RequestAsTab getAllData={ getAllData } setAsFilters={ asFilters } setRequestAs={ setRequestAs } />

        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <Popconfirm
            description="Which Action You Want to Perform?"
            okText="Approve"
            cancelText="Reject"
            onConfirm={ () => onApproveBulk(true) }
            onCancel={ () => onApproveBulk(false) }
          >
            { selectedRows.length > 0 && <CustomButton loading={ loader } key="create_button" text='Approve / Reject' /> }
          </Popconfirm>
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
          rowSelection={ {
            type: 'checkbox',
            ...rowSelection,
          } }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexRelaxationApprovals;
const filterFields = getRequestFilters('')
